<template>
	<div class="this-page printer" v-if="load.base" >
		<div class="title">
			<div class="title-value">DELIVERY LIST<div class="title-small">Standard Customer</div></div>
			<div class="co-info">
				<div class="co-info-text">{{base.appName}}</div>
				<div class="co-info-text">{{base.coName}}</div>
				<div class="co-info-text">Add:{{base.coAddress}}</div>
				<div class="co-info-text">Phone:{{base.coPhone}}</div>
			</div>
		</div>
		<div class="print-body">
			<div class="base-info">
				<div class="base-text">Date: {{base.date}}</div>
				<div class="base-text">Express No: {{base.order.no}}</div>
				<div class="base-text">Member No: {{base.order.uid}}</div>
				<div class="base-text">VIP: {{base.vip > 0 ?'Lv'+base.vip:'-'}}</div>
				<div class="base-text">Send From: {{base.order.poster}}</div>
				<div class="base-text">Method: {{base.order.method == 1?'网点自寄':''}} {{base.order.method == 0?'默认':''}} {{base.order.method == 2?'上门取件':''}} {{base.order.method == 3?'集运':''}} {{base.order.method == 4?'家家团':''}} {{base.order.sendHome == 1?'送货到家':''}} {{base.order.sendHome == 0 && base.order.method > 2 ?'货物自提':''}}</div>
				<div class="base-text">Consignee: {{base.order.receiver}}</div>
				<div class="base-text">Consignee Phone: {{base.order.receiverPhone}}</div>
				<div class="base-text addr">Consignee Add: {{base.order.receiverAddress}}</div>
			</div>
			<template>
			  <el-table
			    :data="base.package"
			    border
				size="small"
				show-summary
				sum-text="Sum"
			    style="width: 100%;">
			    <el-table-column
			      prop="express_no"
			      label="Express No"
				  v-if="base.order.method > 2"
				  min-width="120px"
			      >
			    </el-table-column>
			    <el-table-column
			      prop="name"
			      label="Preview"
				  v-if="base.order.method <= 2"
				  min-width="120px"
			      >
			    </el-table-column>
				<el-table-column
				  prop="package_mark"
				  label="Preview"
				  min-width="120px"
				  v-if="base.order.method > 2"
				  >
				</el-table-column>

				<el-table-column
				  prop="number"
				    v-if="base.order.method <=2"
				  label="QTY">
				</el-table-column>
				<el-table-column
				  prop="item_number"
				    v-if="base.order.method > 2"
				  label="QTY">
				</el-table-column>
				<el-table-column
				  prop="volume"
				  label="Volume"
				  v-if="base.order.method > 2"
				  >
				</el-table-column>
				<el-table-column
				  prop="weight"
				  label="Weight"
				  v-if="base.order.method > 2"
				  >
				</el-table-column>
				<el-table-column
				  prop="total_price"
				  label="Value">
				</el-table-column>
				<el-table-column
				  prop="gst"
				  label="GST">
				</el-table-column>
			  </el-table>
			</template>
			<div class="signature"><div style="padding-bottom: 20px;">Signature:</div><div>Date: {{base.date}}</div></div>
      <div class="tips">
        <div class="tips-item">
          DELIVERY ATTENTION
        </div>
        <div class="tips-item">
          Please advise customer 1hr prior before arrival!
        </div>
        <div class="tips-item">
          NOTCE注意：
        </div>
        <div class="tips-item">
          签收前，请清点货物件数，检查货物是否完整。签收后，说明我司已完成运输服务，若有异议应当时提出并备注在送货单，3个自然日内反映到我司。超过3天我司视为货物已完成好交付。
        </div>
        <div class="tips-item">
          Please check the goods before signing receipt, checking its external packaging and quantities. The shipping consignee service will be finished once the delivery order is signed, Any questions. Pls put forward and remarks on the delivery order and this PO have to present to us within 3 days. WE will regard the shipment as completed if no claim request after 3 days.
        </div>

        <div class="tips-item">
          THANK YOU FOR YOUR BUSINESS!
        </div>


      </div>
		</div>


	</div>
</template>
<script>

	export default {
		components: {

		},
		data() {
			return {
				id: '',
				load: {
					base: false
				},
				base: {},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getBase()
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			getBase() {
				this.$fetch.post('Order/getPrintData', {
					id: this.id
				}, true).then(res => {
					this.load.base = true
					this.base = res
				})
			}
		}
	}
</script>

<style>

	.this-page {
		max-width: 794px;
		min-height: 1000px;
		background-color: #FFFFFF;
		margin: 0 auto;

	}
	.co-info{
		font-size: 13px;
		padding: 20px;
		text-align: right;
	}
	@page { margin: 0; }
	@media print {
		html,body{
			min-width: 794px !important;
			background-color: #FFFFFF;
		}
	  .printer {

	  	width: 794px !important;
	  	min-height: 1000px;
	  	background-color: #FFFFFF;
	  }
	}
	.title{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.title-value{
		padding:20px;
		font-size: 30px;
		font-weight: bold;
	}
	.title-small{
		font-size: 17px;
	}
	.print-body{
		padding: 20px;
	}
	.signature{
		padding-top: 50px;
		font-size: 14px;
	}
	.base-info{
		padding-bottom: 50px;
		font-size: 14px;
		display: flex;
		flex-wrap: wrap;
	}
	.base-text{
		flex: 0 0 50%;
		padding:5px 0;
	}
	.addr{
		flex: 1;
	}
  .tips{
    padding-top: 50px;
  }
  .tips-item{
    font-size: 12px;
    padding-top: 20px;
    font-weight: bold;
  }
</style>
